import request from '@/utils/request'

export const pageListApi = (data) => {
  return request({
    url: 'AnnualLeave/adminList',
    method: 'post',
    data
  })
}

export const auditApi = (data) => {
  return request({
    url: 'AnnualLeave/audit',
    method: 'post',
    data
  })
}
